import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../base/Logo';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const areas = [
    { name: 'Bellville', path: '/bellville-painters' },
    { name: 'Parow', path: '/parow-painters' },
    { name: 'Goodwood', path: '/goodwood-painters' },
    { name: 'Elsies River', path: '/elsies-river-painters' },
    { name: 'Kuils River', path: '/kuils-river-painters' },
    { name: 'Brackenfell', path: '/brackenfell-painters' },
    { name: 'Kraaifontein', path: '/kraaifontein-painters' },
    { name: 'Milnerton', path: '/milnerton-painters' },
    { name: 'Table View', path: '/table-view-painters' },
    { name: 'Bloubergstrand', path: '/bloubergstrand-painters' },
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <Logo className="mb-4" color="white" />
            <p className="text-gray-300 mb-4">
              Get quotes from the best painting contractors in Durbanville and surrounding areas. 
              Professional, reliable, and highest quality workmanship guaranteed.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-[#e9f638] transition-colors duration-200">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#e9f638] transition-colors duration-200">
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#e9f638] transition-colors duration-200">
                <i className="ri-twitter-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li><span className="text-gray-300 hover:text-[#e9f638] transition-colors duration-200">Interior Painting</span></li>
              <li><span className="text-gray-300 hover:text-[#e9f638] transition-colors duration-200">Exterior Painting</span></li>
              <li><span className="text-gray-300 hover:text-[#e9f638] transition-colors duration-200">Roof Painting</span></li>
              <li><span className="text-gray-300 hover:text-[#e9f638] transition-colors duration-200">Commercial Painting</span></li>
              <li><span className="text-gray-300 hover:text-[#e9f638] transition-colors duration-200">Residential Painting</span></li>
            </ul>
          </div>

          {/* Areas We Serve */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Areas We Serve</h3>
            <ul className="space-y-2">
              {areas.slice(0, 6).map((area) => (
                <li key={area.path}>
                  <Link 
                    to={area.path} 
                    className="text-gray-300 hover:text-[#e9f638] transition-colors duration-200"
                  >
                    {area.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Get In Touch</h3>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-map-pin-line text-[#e9f638] mr-3"></i>
                <span className="text-gray-300">Durbanville, Western Cape</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line text-[#e9f638] mr-3"></i>
                <span className="text-gray-300">info@durbanvillepainters.com</span>
              </div>
              <div className="flex items-center">
                <i className="ri-time-line text-[#e9f638] mr-3"></i>
                <span className="text-gray-300">Mon-Fri: 8AM-5PM</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © {currentYear} Durbanville Painters. All rights reserved.
            </p>
            <div className="flex items-center space-x-4 mt-4 md:mt-0">
              <a 
                href="https://seostudio.co.za" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#e9f638] transition-colors duration-200 text-sm"
              >
                SEO by SEO Studio
              </a>
              <span className="text-gray-600">|</span>
              <a 
                href="https://leaderr.co" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-[#e9f638] transition-colors duration-200 text-sm"
              >
                Powered by leaderr
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
